'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMicNone = function MdMicNone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 18.4h2.8c0 5.7-4.5 10.4-10 11.1v5.5h-3.2v-5.5c-5.5-0.8-10-5.4-10-11.1h2.8c0 5 4.2 8.4 8.8 8.4s8.8-3.4 8.8-8.4z m-10.8-10.2v10.3c0 1.1 0.9 2 2 2s2-0.9 2-2l0-10.3c0-1.1-0.9-2-2-2s-2 0.9-2 2z m2 15.2c-2.7 0-5-2.3-5-5v-10c0-2.8 2.3-5 5-5s5 2.2 5 5v10c0 2.7-2.3 5-5 5z' })
        )
    );
};

exports.default = MdMicNone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/mic-none.js
// module id = 1737
// module chunks = 168707334958949